import { defineAction } from '~/prix'
import { z } from 'zod'
import expression from '~/prix/types/expression'
import { enumerated } from '~/prix/types/enumerated'
import animalProductionListAction from './animalProductionList.action.json' with { type: 'json' }
import { animalProductionObject } from '../animalProductionObject'

export const animalProductionExpression = expression(animalProductionObject.shape)

const animalProductionListDefinition = defineAction({
  ...animalProductionListAction,

  input: z.object({
    filter: animalProductionExpression.nullish(),
    limit: z.number().min(1).max(5000).nullish(),
    offset: z.number().nullish(),
    orderBy: enumerated({
      createdAt: 'Data de criação',
      updatedAt: 'Data de atualização',
      synchronizedAt: 'Data de sincronização',
      id: 'Identificador',
      ruralPropertyId: 'Propriedade rural',
      animalProductionType: 'Tipo de produção animal',
      quantity: 'Quantidade',
    }).nullish(),
    order: enumerated({
      ascending: 'Ascendente',
      descending: 'Descendente',
    }).nullish(),
    includeDeleted: z.boolean().nullish(),
  }),
  output: z.object({
    items: z.array(animalProductionObject),
    count: z.number(),
  }),
})

export default animalProductionListDefinition
